import React, { StrictMode, type JSX } from "react";

import { useFeatureFlag } from "../utils/hooks/useFeatureFlag";

interface ConditionalStrictModeProps {
    enabled: boolean;
    children: React.ReactElement;
}
const ConditionalStrictMode = ({
    enabled,
    children,
}: ConditionalStrictModeProps): JSX.Element => {
    return enabled ? <StrictMode>{children}</StrictMode> : children;
};

type StrictModeBoundary = "orgEntry" | "controlView";
interface FlipperStrictModeProps {
    children: React.ReactElement;
    boundaryKey: StrictModeBoundary;
}
export const FlipperStrictMode = ({
    children,
    boundaryKey,
}: FlipperStrictModeProps) => {
    const enabled = useFeatureFlag(`${boundaryKey}StrictMode`);

    return (
        <ConditionalStrictMode enabled={enabled}>
            {children}
        </ConditionalStrictMode>
    );
};
